module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/bp-2-500.4bd6cb62e0c14452.jpg"+" 500w",
        images: [{path: "https://static.sniffspot.com/packs/img/bp-2-500.4bd6cb62e0c14452.jpg",width: 500,height: 337}],
        src: "https://static.sniffspot.com/packs/img/bp-2-500.4bd6cb62e0c14452.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/bp-2-500.4bd6cb62e0c14452.jpg"},
        
        width: 500,
        height: 337
      }